// extracted by mini-css-extract-plugin
export var container = "_cc-0";
export var popoverContent = "_cc-1";
export var tosLink = "_cc-2";